import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Invoice } from '../domain/dtos/invoice'
import { Envs } from '../envs'

export class GetInvoice {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<Invoice> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/payer/invoices/${id}`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new Error('Erro ao buscar fatura')
  }
}
